/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-arrows-horizontal': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M7.131 16.619l-2.237-2.244H17.5v-1.25H4.894l2.237-2.244L6.25 10 2.5 13.75l3.75 3.75.881-.881zM17.5 6.25L13.75 2.5l-.881.881 2.237 2.244H2.5v1.25h12.606L12.87 9.119l.881.881 3.75-3.75z"/>'
  }
})
